import { z } from 'zod'

export const publicEnvSchema = z.object({
  NEXT_PUBLIC_API_HOST: z.string(),
  NEXT_PUBLIC_AUTH0_DOMAIN: z.string(),
  NEXT_PUBLIC_AUTH0_SPA_APP_CLIENT_ID: z.string(),
  NEXT_PUBLIC_BUGSNAG_API_KEY: z.string().optional(),
  NEXT_PUBLIC_MANAGER_CLIENT_URL: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_API_URL: z.string().optional(),
})
